<template>
   <b-card-actions no-body   class="card-employee-task" title="المستخدمين المتواجدين اونلاين">
  

    <!-- body -->
    <b-card-body v-if="!load">
      <div
        v-for="employee in users"
        :key="employee.id"
        class="employee-task d-flex justify-content-between align-items-center"
      >
        <b-media no-body>
          <b-media-aside class="mr-75">
            <b-avatar rounded size="42" :src="employee.profile_image_path" />
          </b-media-aside>
          <b-media-body class="my-auto">
            <h6 class="mb-0">
              {{ employee.full_name }}
            </h6>
            <!-- <small>{{ employee.email }}</small> -->
          </b-media-body>
        </b-media>
        <div class="d-flex align-items-center">
          <b-badge
            variant="success"
            class="badge-glow"
            v-if="employee.account_type == 'student'"
          >
            {{ employee.account_type }}
          </b-badge>
          <b-badge
            variant="info"
            class="badge-glow"
            v-if="employee.account_type == 'teacher'"
          >
            {{ employee.account_type }}
          </b-badge>
        </div>
      </div>
    </b-card-body>
    <b-spinner v-else type="grow" label="Loading..."  class="loading" />
  </b-card-actions>
</template>

<script>
 
 
import Auth from "@/Apis/Auth";
import Users from "@/Apis/Users";
/* eslint-disable global-require */
const $trackBgColor = "#e9ecef";
 
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
export default {

  components: {
    BCardActions,
   
  },
  data() {
    return {
      users: [],
      load: false,
    };
  },
  mounted: function () {
    this.getOnline();
  },
  async created() {
    this.getOnline();
  },
  methods: {
    getOnline: async function () {
      this.load = true;
      let eduProgramId = localStorage.getItem("eduProgram");
      let roomData = Auth.ROOM.find((a) => a.edu_program_id == eduProgramId);
      let room = roomData.id;
      let user = Auth.USER;
      if (user.account_type == "teacher") room = localStorage.getItem("room");
      this.users = await new Users().getAllOnline({roomId:room});
      this.load = false;
    },
    live() {
      this.intervalid1 = setInterval(() => {
        this.getOnline();
      }, 900);
    },
  },
};
/* eslint-disable global-require */
</script>
